import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class TvMenuRefreshService {
  private readonly reloadRequestedSubject = new Subject<void>();
  readonly reloadRequested$ = this.reloadRequestedSubject.asObservable();

  requestReload(): void {
    this.reloadRequestedSubject.next();
  }
}
